export default "__VITE_ASSET__C0$z9rWC__"